import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { SedsModalService, SedsSizeOptions } from "experian-design-system";
import { BehaviorSubject, Observable, tap } from "rxjs";

import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SiteSection } from "../../../../../shared/enums/site-section.enum";
import { AnalyticsService } from "../../../../../shared/services/analytics.service";
import { SidenavManagerService } from "../../../../../shared/services/sidenav.manager.service";
import { Logon } from "../../../users/interfaces/logon.interface";
import { ResetUser } from "../../../users/interfaces/reset-user.interface";
import { User } from "../../../users/interfaces/user.interface";
import {
  loadSelectedLogon,
  loadToggleSidenav,
  resetUser,
  resetUserSuccess,
} from "../../../users/state/actions/user.actions";
import {
  selectLogon,
  selectResetStatus,
} from "../../../users/state/selectors/user.selectors";
import { loadResetBlockUser } from "../../state/actions/dashboard.actions";

@Component({
    selector: "pl-reset-password",
    templateUrl: "reset-password.component.html",
    styleUrls: ["reset-password.component.scss", "../../../../../styles/theme/modal.scss"],
    standalone: false
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  public isAllowedToResetPassword!: boolean;
  public smallButton = SedsSizeOptions.SMALL;
  public resetStatus = new BehaviorSubject("default");
  public data: any = null;
  public selectedLogon$!: Observable<Partial<Logon | undefined>>;
  public messageAlert = `Estamos trabalhando para resolver esse problema.
  Por favor tente novamente mais tarde, e se o erro persistir, entre em contato com a nossa equipe de atendimento.`;
  public resetUserData!: ResetUser;
  public isEdit!: boolean;

  constructor(
    private readonly _dialogRef: SedsModalService,
    private readonly _sidenavManagerService: SidenavManagerService,
    private readonly store: Store,
    private readonly _cdr: ChangeDetectorRef,
    private readonly _analyticsService: AnalyticsService,
    @Inject(MAT_DIALOG_DATA) public modalData: { byUserDetails: boolean },
  ) {}

  ngOnInit(): void {
    this._analyticsService.doPageLoad(SiteSection.REDEFINIR_SENHA);

    this.store.dispatch(resetUserSuccess({ resetStatus: "default" }));
    this.store
      .select(selectResetStatus)
      .pipe(tap((reset) => this.resetStatus.next(reset || "default")))
      .subscribe();
    this.selectedLogon$ = this.store.select(selectLogon);
    this.getData();
  }

  private getData() {
    this.selectedLogon$
      .pipe(
        tap((logon) => (this.data = logon ? logon : null)),
        tap((logon) => {
          if (logon) {
            const { fullname, document, alternativeEmail, phone, logon } =
              this.data;
            this.resetUserData = {
              fullName: fullname ?? "",
              email: alternativeEmail?.email ?? "",
              logon: logon ?? "",
            };
            this.isAllowedToResetPassword = Boolean(
              fullname && document && (alternativeEmail || phone),
            );
            this._cdr.detectChanges();
          }
        }),
      )
      .subscribe();
  }

  public resetPassword(): void {
    this.store.dispatch(resetUser({ resetUser: this.resetUserData }));
  }

  public editUser(): void {
    this.data = {
      ...this.data,
      name: this.data.fullname,
    };

    this._setCurrentUser(this.data);
    this._openSidenav();
    this.isEdit = true;

    this._sidenavManagerService.resetPasswordFlow$.next(true);
    this._sidenavManagerService.navigate$.next("edit");
    this.done();
  }

  private _setCurrentUser(user: User) {
    this.store.dispatch(
      loadSelectedLogon({
        selectedUserId: user?.userId || "",
        userDataTable: user,
      }),
    );
  }

  private _openSidenav() {
    this.store.dispatch(
      loadToggleSidenav({
        openSidenav: true,
      }),
    );
  }

  public done(): void {
    this._dialogRef.close();
  }

  ngOnDestroy(): void {
    if (!this.modalData?.byUserDetails && !this.isEdit) {
      this._sidenavManagerService.navigate$.next("");
    }

    if (!this.isEdit) {
      this.store.dispatch(loadResetBlockUser({ selectedLogon: this.data }));
    }
  }
}
